// extracted by mini-css-extract-plugin
module.exports = {"mt5":"landing-page-module--mt-5--3c_TQ","my5":"landing-page-module--my-5--1G8w5"};